import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "navbar-nav" }
const _hoisted_4 = { class: "navbar-seller-name" }
const _hoisted_5 = { class: "text-black" }
const _hoisted_6 = {
  key: 0,
  class: "navbar-seller-shop-name text-black"
}
const _hoisted_7 = ["aria-expanded"]
const _hoisted_8 = {
  key: 0,
  class: "dropdown-loading"
}
const _hoisted_9 = { class: "dropdown-item" }
const _hoisted_10 = { class: "dropdown-item-content" }
const _hoisted_11 = { class: "dropdown-item-value" }
const _hoisted_12 = { class: "dropdown-item" }
const _hoisted_13 = { class: "dropdown-item-content" }
const _hoisted_14 = { class: "dropdown-item-value" }
const _hoisted_15 = { class: "dropdown-item" }
const _hoisted_16 = { class: "dropdown-item-content" }
const _hoisted_17 = { class: "dropdown-item-value" }
const _hoisted_18 = { class: "dropdown-item" }
const _hoisted_19 = { class: "dropdown-item-content" }
const _hoisted_20 = { class: "dropdown-item-value" }
const _hoisted_21 = {
  key: 0,
  class: "dropdown-item"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "dropdown-item" }
const _hoisted_24 = { class: "navbar-mobile-container" }
const _hoisted_25 = ["aria-expanded"]
const _hoisted_26 = { class: "navbar-mobile-buttons" }
const _hoisted_27 = ["aria-expanded"]
const _hoisted_28 = {
  key: 0,
  class: "dropdown-loading"
}
const _hoisted_29 = { class: "dropdown-item" }
const _hoisted_30 = { class: "dropdown-item-content" }
const _hoisted_31 = { class: "dropdown-item-value" }
const _hoisted_32 = { class: "dropdown-item" }
const _hoisted_33 = { class: "dropdown-item-content" }
const _hoisted_34 = { class: "dropdown-item-value" }
const _hoisted_35 = { class: "dropdown-item" }
const _hoisted_36 = { class: "dropdown-item-content" }
const _hoisted_37 = { class: "dropdown-item-value" }
const _hoisted_38 = { class: "dropdown-item" }
const _hoisted_39 = { class: "dropdown-item-content" }
const _hoisted_40 = { class: "dropdown-item-value" }
const _hoisted_41 = { class: "dropdown-item" }

import { ref, onMounted, onUnmounted, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getVendeurGeneralInfo } from "@/api/vendeur";
import { useAuthStore } from "@/stores/auth";
import type { NavbarProps, NavbarEmits } from "@/types";

const LOCAL_STORAGE_KEY = "vendeur_info_header";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavbar',
  props: {
    isLoading: { type: Boolean },
    vendeurData: {},
    isSidebarCollapsed: { type: Boolean },
    isSidebarOpen: { type: Boolean }
  },
  emits: ["toggle-sidebar-collapsed", "toggle-sidebar", "show-contact-modal", "show-user-modal"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();


const isDashboardRoute = computed(() => {
  return route.path.startsWith("/dashboard");
});

// Génère un slug URL-friendly à partir d'une chaîne
const getSlug = (str: string): string => {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Supprime les accents
    .replace(/[^a-z0-9]+/g, "-") // Remplace les caractères spéciaux par des tirets
    .replace(/^-+|-+$/g, ""); // Supprime les tirets en début/fin
};

// URL de la page vendeur
const vendeurPageUrl = computed(() => {
  const nomBoutique = vendeurData.value.nomBoutique;
  const idVendeur = vendeurData.value.id_vendeur;
  if (!nomBoutique || !idVendeur) return "";
  const slug = getSlug(nomBoutique);
  return `https://www.efashion-paris.com/vendeurs/${slug}-${idVendeur}.html`;
});

// Dropdown
const dropdownRef = ref<HTMLElement | null>(null);
const dropdownMobileRef = ref<HTMLElement | null>(null);
const isDropdownOpen = ref(false);
const isDropdownMobileOpen = ref(false);

const handleClickOutside = (event: Event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isDropdownOpen.value = false;
  }
  if (
    dropdownMobileRef.value &&
    !dropdownMobileRef.value.contains(event.target as Node)
  ) {
    isDropdownMobileOpen.value = false;
  }
};

const DEFAULT_VENDEUR = {
  nomSociete: "non disponible",
  email: "non disponible",
  telephone: "non disponible",
  mobile: "non disponible",
  adresse: "non disponible",
  code_postal: "non disponible",
  ville: "non disponible",
  nomBoutique: "",
  id_vendeur: 0,
};

const isLoading = ref(true);
const vendeurData = ref({ ...DEFAULT_VENDEUR });
const hasCurrentAddressCache = ref(false);

const adminOrderShopName = computed(() => {
  if (
    !authStore.isImpersonating ||
    route.name !== "orderdetails-detail" ||
    !vendeurData.value.nomBoutique
  ) {
    return "";
  }

  const companyName = vendeurData.value.nomSociete.trim().toLocaleLowerCase();
  const shopName = vendeurData.value.nomBoutique.trim();

  return shopName.toLocaleLowerCase() === companyName ? "" : shopName;
});

const loadFromStorage = () => {
  const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!raw) {
    isLoading.value = false;
    return;
  }

  try {
    const saved = JSON.parse(raw) as Partial<typeof DEFAULT_VENDEUR>;
    hasCurrentAddressCache.value = Object.prototype.hasOwnProperty.call(
      saved,
      "ville",
    );
    vendeurData.value = {
      ...DEFAULT_VENDEUR,
      ...saved,
    };
  } catch (e) {
    // Erreur silencieuse - les infos vendeur restent vides
  } finally {
    isLoading.value = false;
  }
};

//save grossiste info into local storage and state
const fetchVendeurInfo = async () => {
  const profile = await getVendeurGeneralInfo();

  const storeAddress = profile.adresses?.find((addr: any) => addr.type === 2);

  const newData = {
    nomSociete: profile.nomSociete || profile.nomBoutique || "non disponible",
    email: profile.email || "non disponible",
    telephone: storeAddress?.telephone || "non disponible",
    mobile: storeAddress?.mobile || "non disponible",
    adresse: storeAddress?.adresse || "non disponible",
    code_postal: storeAddress?.codePostal || "non disponible",
    ville: storeAddress?.ville || "non disponible",
    nomBoutique: profile.nomBoutique || "",
    id_vendeur: profile.id_vendeur || 0,
  };

  vendeurData.value = newData;
  hasCurrentAddressCache.value = true;
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newData));
};

const refreshFromApiIfNeeded = async () => {
  if (!authStore.isInitialized) {
    await authStore.checkAuth();
  }

  if (!authStore.isAuthenticated) return;

  const authVendeurId = authStore.user?.id_vendeur ?? authStore.user?.id;
  const cachedId = vendeurData.value.id_vendeur;

  // Ne pas recharger que si le cache correspond au vendeur authentifié
  if (
    vendeurData.value.nomBoutique &&
    hasCurrentAddressCache.value &&
    cachedId &&
    authVendeurId &&
    cachedId === authVendeurId
  ) {
    return;
  }

  isLoading.value = true;
  try {
    await fetchVendeurInfo();
  } catch (error) {
    // Erreur silencieuse - les infos vendeur n'ont pas été chargées
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);

  loadFromStorage();

  void refreshFromApiIfNeeded();
});

watch(
  () => route.path,
  () => {
    void refreshFromApiIfNeeded();
  },
);

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

const toggleSidebarCollapsed = () => {
  emit("toggle-sidebar-collapsed");
};

const toggleSidebar = () => {
  emit("toggle-sidebar");
};

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const toggleDropdownMobile = () => {
  isDropdownMobileOpen.value = !isDropdownMobileOpen.value;
};

function seDeconnecter() {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
  authStore.logout();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("button", {
      onClick: toggleSidebarCollapsed,
      class: _normalizeClass(["sidebar-toggle-btn", { 'sidebar-collapsed': _ctx.isSidebarCollapsed }]),
      title: 
        _ctx.isSidebarCollapsed ? 'Étendre la sidebar' : 'Rétracter la sidebar'
      
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("i", { class: "fas fa-bars" }, null, -1)
    ]), 10, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'catalog/mel' }))),
        class: "navbar-btn-secondary"
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("i", {
          class: "fas fa-plus",
          style: {"font-size":"0.95em"}
        }, null, -1),
        _createElementVNode("span", null, "Créer un produit", -1)
      ])),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(isLoading.value ? "Chargement..." : vendeurData.value.nomSociete), 1),
        (adminOrderShopName.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(adminOrderShopName.value) + ") ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "navbar-dropdown",
        ref_key: "dropdownRef",
        ref: dropdownRef
      }, [
        _createElementVNode("button", {
          class: "navbar-dropdown-toggle",
          onClick: toggleDropdown,
          "aria-expanded": isDropdownOpen.value
        }, _cache[6] || (_cache[6] = [
          _createElementVNode("i", { class: "fas fa-user" }, null, -1)
        ]), 8, _hoisted_7),
        _createElementVNode("ul", {
          class: _normalizeClass(["navbar-dropdown-menu", isDropdownOpen.value ? 'is-open' : 'is-closed'])
        }, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1),
                _createElementVNode("span", null, "Chargement des informations...", -1)
              ])))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[19] || (_cache[19] = _createElementVNode("li", { class: "dropdown-section-title" }, [
                  _createElementVNode("i", { class: "fas fa-user-circle" }),
                  _createElementVNode("span", null, "Informations personnelles")
                ], -1)),
                _createElementVNode("li", _hoisted_9, [
                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-envelope" }, null, -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "dropdown-item-label" }, "Email", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(vendeurData.value.email), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_12, [
                  _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-phone" }, null, -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "dropdown-item-label" }, "Téléphone fixe", -1)),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(vendeurData.value.telephone), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_15, [
                  _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-mobile-alt" }, null, -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "dropdown-item-label" }, "Téléphone mobile", -1)),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(vendeurData.value.mobile), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "dropdown-item-label" }, "Adresse", -1)),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(vendeurData.value.adresse) + " , " + _toDisplayString(vendeurData.value.code_postal) + " " + _toDisplayString(vendeurData.value.ville), 1)
                  ])
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("li", { class: "dropdown-section-title" }, [
                  _createElementVNode("i", { class: "fas fa-external-link-alt" }),
                  _createElementVNode("span", null, "Liens utiles")
                ], -1)),
                (vendeurPageUrl.value)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                      _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-store" }, null, -1)),
                      _createElementVNode("a", {
                        href: vendeurPageUrl.value,
                        target: "_blank"
                      }, "Voir ma page", 8, _hoisted_22)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("li", _hoisted_23, [
                  _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-headset" }, null, -1)),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('show-contact-modal')))
                  }, "Contactez nous")
                ]),
                _cache[21] || (_cache[21] = _createStaticVNode("<li class=\"dropdown-item\" data-v-5ddc08d0><i class=\"fas fa-book\" data-v-5ddc08d0></i><a href=\"https://knowledge.efashion-paris.com/vendors\" target=\"_blank\" data-v-5ddc08d0>Guide Efashion</a></li><li class=\"dropdown-item\" data-v-5ddc08d0><i class=\"fas fa-file-contract\" data-v-5ddc08d0></i><a href=\"https://landingpage.efashion-paris.com/fr/conditions-g%C3%A9n%C3%A9rales-dutilisation-grossistes-vendeurs\" target=\"_blank\" data-v-5ddc08d0>CGUV</a></li><li class=\"dropdown-divider\" data-v-5ddc08d0></li>", 3)),
                _createElementVNode("li", {
                  class: "dropdown-item dropdown-logout",
                  onClick: seDeconnecter
                }, _cache[18] || (_cache[18] = [
                  _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1),
                  _createElementVNode("a", { href: "#" }, "Déconnexion", -1)
                ]))
              ], 64))
        ], 2)
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("button", {
        type: "button",
        onClick: toggleSidebar,
        "aria-controls": "sidebarMenu",
        "aria-expanded": _ctx.isSidebarOpen,
        "aria-label": "Toggle navigation",
        class: "navbar-mobile-burger"
      }, _cache[22] || (_cache[22] = [
        _createElementVNode("i", { class: "fas fa-bars" }, null, -1)
      ]), 8, _hoisted_25),
      _createElementVNode("ul", _hoisted_26, [
        _createElementVNode("li", null, [
          _createElementVNode("div", {
            class: "navbar-dropdown",
            ref_key: "dropdownMobileRef",
            ref: dropdownMobileRef
          }, [
            _createElementVNode("button", {
              class: "navbar-dropdown-toggle",
              onClick: toggleDropdownMobile,
              "aria-expanded": isDropdownMobileOpen.value
            }, _cache[23] || (_cache[23] = [
              _createElementVNode("i", { class: "fas fa-user" }, null, -1)
            ]), 8, _hoisted_27),
            _createElementVNode("ul", {
              class: _normalizeClass(["navbar-dropdown-menu", isDropdownMobileOpen.value ? 'is-open' : 'is-closed'])
            }, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_28, _cache[24] || (_cache[24] = [
                    _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1),
                    _createElementVNode("span", null, "Chargement des informations...", -1)
                  ])))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[35] || (_cache[35] = _createElementVNode("li", { class: "dropdown-section-title" }, [
                      _createElementVNode("i", { class: "fas fa-user-circle" }),
                      _createElementVNode("span", null, "Informations personnelles")
                    ], -1)),
                    _createElementVNode("li", _hoisted_29, [
                      _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fas fa-envelope" }, null, -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "dropdown-item-label" }, "Email", -1)),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(vendeurData.value.email), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_32, [
                      _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fas fa-phone" }, null, -1)),
                      _createElementVNode("div", _hoisted_33, [
                        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "dropdown-item-label" }, "Téléphone fixe", -1)),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(vendeurData.value.telephone), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_35, [
                      _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fas fa-mobile-alt" }, null, -1)),
                      _createElementVNode("div", _hoisted_36, [
                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "dropdown-item-label" }, "Téléphone mobile", -1)),
                        _createElementVNode("span", _hoisted_37, _toDisplayString(vendeurData.value.mobile), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_38, [
                      _cache[32] || (_cache[32] = _createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1)),
                      _createElementVNode("div", _hoisted_39, [
                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "dropdown-item-label" }, "Adresse", -1)),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(vendeurData.value.adresse) + " , " + _toDisplayString(vendeurData.value.code_postal) + " " + _toDisplayString(vendeurData.value.ville), 1)
                      ])
                    ]),
                    _cache[36] || (_cache[36] = _createElementVNode("li", { class: "dropdown-section-title" }, [
                      _createElementVNode("i", { class: "fas fa-external-link-alt" }),
                      _createElementVNode("span", null, "Liens utiles")
                    ], -1)),
                    _createElementVNode("li", _hoisted_41, [
                      _cache[33] || (_cache[33] = _createElementVNode("i", { class: "fas fa-headset" }, null, -1)),
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = 
                      () => {
                        isDropdownMobileOpen.value = false;
                        emit('show-contact-modal');
                      }
                    )
                      }, "Contactez nous")
                    ]),
                    _cache[37] || (_cache[37] = _createStaticVNode("<li class=\"dropdown-item\" data-v-5ddc08d0><i class=\"fas fa-book\" data-v-5ddc08d0></i><a href=\"https://knowledge.efashion-paris.com/vendors\" target=\"_blank\" data-v-5ddc08d0>Guide Efashion</a></li><li class=\"dropdown-item\" data-v-5ddc08d0><i class=\"fas fa-file-contract\" data-v-5ddc08d0></i><a href=\"https://landingpage.efashion-paris.com/fr/conditions-g%C3%A9n%C3%A9rales-dutilisation-grossistes-vendeurs\" target=\"_blank\" data-v-5ddc08d0>CGUV</a></li><li class=\"dropdown-divider\" data-v-5ddc08d0></li>", 3)),
                    _createElementVNode("li", {
                      class: "dropdown-item dropdown-logout",
                      onClick: _cache[3] || (_cache[3] = 
                    () => {
                      isDropdownMobileOpen.value = false;
                      seDeconnecter();
                    }
                  )
                    }, _cache[34] || (_cache[34] = [
                      _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1),
                      _createElementVNode("a", { href: "#" }, "Déconnexion", -1)
                    ]))
                  ], 64))
            ], 2)
          ], 512)
        ])
      ])
    ])
  ]))
}
}

})